// extracted by mini-css-extract-plugin
export default {"favIcon":"styles_favIcon__SuRAn"};